import { Check } from "lucide-react";
import { COMPARE_ROWS } from "@/data/content";
import { Reveal, SectionHeading } from "@/components/site/primitives";
import { useApply } from "@/context/ApplyContext";
import { useSiteConfig } from "@/context/SiteConfigContext";
import { waHref } from "@/lib/links";

export function Compare() {
  const apply = useApply();
  const { config } = useSiteConfig();
  return (
    <section className="relative py-20 sm:py-28 bg-white" data-testid="compare-section">
      <div className="container-x">
        <SectionHeading overline="JUPEB • IJMB • Remedial" title="Which Pathway Is Right for You?" align="center"
          subtitle="Compare our three routes to university. Each is a respected pathway — the right choice depends on your goals and results." />

        <Reveal>
          <div className="mt-12 overflow-hidden rounded-sm border border-slate-200 shadow-sm">
            <div className="grid grid-cols-4 bg-[#0A1E4E] text-white">
              <div className="p-3 sm:p-5 text-[11px] sm:text-sm font-bold uppercase tracking-wider">Feature</div>
              <div className="p-3 sm:p-5 text-center text-xs sm:text-lg font-serif font-bold text-[#D4AF37] border-l border-white/10">JUPEB</div>
              <div className="p-3 sm:p-5 text-center text-xs sm:text-lg font-serif font-bold text-[#D4AF37] border-l border-white/10">IJMB</div>
              <div className="p-3 sm:p-5 text-center text-xs sm:text-lg font-serif font-bold text-[#D4AF37] border-l border-white/10">Remedial</div>
            </div>
            {COMPARE_ROWS.map((row, i) => (
              <div key={row[0]} className={`grid grid-cols-4 ${i % 2 ? "bg-[#F7F5EF]" : "bg-white"}`}>
                <div className="p-3 sm:p-5 text-xs sm:text-sm font-semibold text-[#0A1E4E]">{row[0]}</div>
                {[row[1], row[2], row[3]].map((v, j) => (
                  <div key={j} className="flex items-center justify-center gap-1.5 p-3 sm:p-5 text-center text-[11px] sm:text-sm text-slate-700 border-l border-slate-200">
                    {v === "Yes" ? <Check size={16} className="text-emerald-600" /> : null}
                    <span>{v}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <button className="btn-navy" onClick={() => apply?.openApply()} data-testid="compare-talk-officer">
              Speak to an Admissions Officer
            </button>
            <a href={waHref(config.whatsapp)} target="_blank" rel="noopener noreferrer" className="btn-outline-gold !text-[#0A1E4E] !border-[#0A1E4E] hover:!bg-[#0A1E4E] hover:!text-white">
              WhatsApp Us
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
